import ApiAutomationsRequest from "../api-request/api-automations";

export default class ApiAutomations {

    static ping() {
        return ApiAutomationsRequest.POST(this,'ping', {})
    }

    getAutomation(id:ID) {
        return ApiAutomationsRequest.GET(this, 'company/view/{0}'.f(id));
    }

    createAutomation(params:any) {
        return ApiAutomationsRequest.POST(this,'company/create', params)

    }

    updateAutomation(id:ID, params:any) {

        // example
        /*const params = {
            "triggerRules": {"==": [{"var": "priority"}, 8]}
        }*/

        return ApiAutomationsRequest.POST(this, 'company/update/{0}'.f(id), params);
    }

    deleteAutomation(id:ID) {
        return  ApiAutomationsRequest.GET(this, 'company/delete/{0}'.f(id));
    }

    getAutomationHistory() {
        return  ApiAutomationsRequest.GET(this, 'company/history');
    }

    // `cid` stays in the query on purpose: jQuery sends a DELETE payload as a
    // body, which this endpoint does not read. Same reason as
    // ApiAutomationsWebhooks.deleteHistory().
    deleteAutomationHistory() {
        return  ApiAutomationsRequest.DELETE(this, 'company/history?cid='+gd.companyId);
    }

    getAutomationDateArrivesQueue() {
        return  ApiAutomationsRequest.GET(this, 'company/job-queue');
    }

    runDateArrivesJob(id:ID) {
        return  ApiAutomationsRequest.GET(this, 'run-job/{0}'.f(id));
    }

    getCompanyAutomations() {
        return  ApiAutomationsRequest.GET(this, 'company/list');
    }

    getProjectAutomations(projectId:ID) {
        return  ApiAutomationsRequest.GET(this, 'company/list/project/{0}'.f(projectId));
    }

    getTaskActions() {
        return  ApiAutomationsRequest.GET(this, 'company/list/actions')
    }

    runTaskAction(taskId:ID, automationId:ID) {
        return ApiAutomationsRequest.POST(this, 'task/{0}/run-action/{1}'.f(taskId, automationId), {});
    }

    // Webhook endpoints (incl. the delivery history) live in ApiAutomationsWebhooks

}
